export const alloggiati = {
  title: "Alloggiati Web",
  subtitle: "تسجيل الضيوف إلكترونياً — Polizia di Stato (إيطاليا)",

  fields: {
    utente: "اسم المستخدم (Utente)",
    password: "كلمة المرور",
    wskey: "WsKey",
    wskeyHint: "يتم إنشاء WsKey في البوابة alloggiatiweb.poliziadistato.it ← Gestione dispositivi.",
    tipoStruttura: "نوع الإقامة",
    idAppartamento: "معرّف الشقة",
    idAppartamentoHint: "معرّف الشقة المسجّل في Alloggiati Web.",
    keepBlank: "(اتركه فارغاً للاحتفاظ بالقيمة الحالية)",
  },

  tipoOptions: {
    hotel: "فندق / نزل / منزل عطلات",
    appartamento: "شقة مُدارة",
  },

  actions: {
    saveAndVerify: "حفظ والتحقق",
    updateCredentials: "تحديث بيانات الاعتماد",
    verifyConnection: "التحقق من الاتصال",
    saving: "جارٍ الحفظ...",
    verifying: "جارٍ التحقق...",
  },

  status: {
    connectionOk: "تم حفظ بيانات الاعتماد والتحقق من الاتصال بنجاح.",
    connectionError: "خطأ في الاتصال. يرجى التحقق من بيانات الاعتماد المُدخلة.",
    connectionPending: "لم يتم التحقق من الاتصال بعد. انقر على «التحقق من الاتصال» للتأكيد.",
  },

  validation: {
    utenteRequired: "حقل Utente مطلوب.",
    passwordRequired: "كلمة المرور مطلوبة.",
    wskeyRequired: "WsKey مطلوبة.",
    idAppartamentoRequired: "معرّف الشقة مطلوب.",
  },

  toasts: {
    saveSuccess: "تم حفظ بيانات الاعتماد والتحقق من الاتصال بنجاح.",
    saveWarning: "تم الحفظ، لكن تعذّر التحقق من الاتصال.",
    saveError: "تعذّر حفظ بيانات الاعتماد.",
    testSuccess: "تم التحقق من اتصال Alloggiati Web بنجاح.",
    testError: "تعذّر التحقق من الاتصال.",
    statusActive: "تم تفعيل Alloggiati Web.",
    statusInactive: "تم إلغاء تفعيل Alloggiati Web.",
  },
};
